export const ADD_QUIZS = 'ADD_QUIZS'